import {
  AdapterSource,
  DispatcherAuthPrefix,
  DispatcherCategoryService,
  DispatcherEndpoint,
  DispatcherResource
} from 'modules/types/common';
import { getDispatcherUrl } from 'modules/utils/UrlUtils';
import { DFDHeaders } from 'serverTypes/authentication';
import { RootDispatch, Thunk } from 'store/types';
import { MhpDetails } from './types';

export const DELETE_DOCUMENT = `MESSAGE.DELETE_DOCUMENT`;
export const DELETE_DOCUMENT_SUCCESS = `MESSAGE.DELETE_DOCUMENT_SUCCESS`;
export const DELETE_DOCUMENT_FAIL = `MESSAGE.DELETE_DOCUMENT_FAIL`;

export const deleteDocument = (messageUUID: string, attachmentUUID: string) => ({
  type: DELETE_DOCUMENT,
  payload: {
    client: 'dispatcher',
    request: {
      method: 'delete',
      headers: {
        [DFDHeaders.contentType]: 'application/x-www-form-urlencoded;charset=UTF-8',
        [DFDHeaders.mhpMessageUuid]: messageUUID,
        [DFDHeaders.resourceId]: attachmentUUID,
        [DFDHeaders.mhpAdapter]: AdapterSource.UTAH
      },
      url: getDispatcherUrl(
        DispatcherCategoryService.HEALTH_RECORDS,
        DispatcherAuthPrefix.AUTHENTICATED,
        DispatcherResource.ATTACHMENTS,
        DispatcherEndpoint.ID
      )
    }
  }
});

export const GET_MESSAGE_BY_ID = 'MESSAGING.GET_MESSAGE_BY_ID';
export const GET_MESSAGE_BY_ID_SUCCESS = 'MESSAGING.GET_MESSAGE_BY_ID_SUCCESS';
export const GET_MESSAGE_BY_ID_FAIL = 'MESSAGING.GET_MESSAGE_BY_ID_FAIL';
export const RESET_MESSAGE_DETAIL = 'MESSAGING.RESET_MESSAGE_DETAIL';
export const getMessageById = (mhpDetails: MhpDetails) => ({
  type: GET_MESSAGE_BY_ID,
  payload: {
    client: 'dispatcher',
    request: {
      method: 'get',
      url: mhpDetails.url || DispatcherEndpoint.FAIL,
      headers: {
        ...mhpDetails.headers
      }
    }
  }
});

export const resetMessageDetail = (): Thunk => (dispatch: RootDispatch) => {
  return dispatch({ type: RESET_MESSAGE_DETAIL });
};

export const MESSAGE_COMPOSE_CLEAR_PROVIDER_SELECTED =
  'MESSAGE.MESSAGE_COMPOSE_CLEAR_PROVIDER_SELECTED';
export const messageComposeClearProviderSelected = () => ({
  type: MESSAGE_COMPOSE_CLEAR_PROVIDER_SELECTED
});
